import { Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import theme from "../../theme";
import useButtonStyles from "../../styles/useButtonStyles";
import { useAppSelector } from "../../redux/hooks";
import axios from "axios";
import { APIConstants, APIModuleConstants } from "../../constants/ApiConstants";
import { Link } from "react-router-dom";
import formatDate from "../../util/dateFormat";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import useGetTotalRecords from "../../Hooks/CustomHooks/UseGetTotalRecords";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import { permissionsConstants } from "../../constants/AppConstants";

interface TableColumn {
  key: string;

  header: string;

  searchable?: boolean;

  filterable?: boolean;
}

const columns: TableColumn[] = [
  { key: "name", header: "Name" },
  { key: "email", header: "Email" },
  { key: "mobileNumber", header: "Mobile Number" },
  { key: "status", header: "Status" },
  { key: "role", header: "Role" },
];

const UserAccessNew = () => {
  const { getUserPermission: userAccessPermissions } = usePermissionGetter(
    permissionsConstants.user_access,
    permissionsConstants.user_access
  );
  const [data, setData] = useState([]);
  const [lastKey, setLastKey] = useState(null);
  const [loading, setLoading] = useState(false);
  const buttonStyles = useButtonStyles();

  const { selectedMerchatDetails } = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList
  );
  const { external_id } = selectedMerchatDetails;
  const { totalCount, getTotalRecordsCount } = useGetTotalRecords();
  const fetchShopUserList = async () => {
    try {
      setLoading(true);
      let url = `${process.env.REACT_APP_API_URL}${APIConstants.admin}`;
      let queryParams = `userType=merchant&filters=merchant_ext_id:contains:${external_id}`;
      url += "?" + queryParams;
      if (lastKey) {
        url += `&lastKey=${encodeURIComponent(JSON.stringify(lastKey))}`;
      }
      if (!data.length)
        getTotalRecordsCount(APIModuleConstants.adminUser, queryParams);
      url += "&module=user_access&feature=user_access";
      const response = await axios.get(url);
      const apidata = response.data.result.data;
      const nextKey = response?.data?.result?.lastKey;
      setLastKey(nextKey ? nextKey : null);
      const shopUserlistData = apidata.map((item: any) => {
        return {
          email: item.email ? item.email : "-",
          name: item.firstName ? `${item.firstName} ${item.lastName}` : "-",
          status: item.status ? item.status : "-",
          role: item.user_role ? item.user_role : "-",
          department: item.department ? item.department : "-",
          merchant: item.merchant ? item.merchant : "-",
          mobileNumber: item.mobile && item.mobile !== "0" ? item.mobile : "-",
          lastLogin: item.lastLogin ? formatDate(item.lastLogin) : "-",
          first_name: item.firstName ? item.firstName : "-",
          last_name: item.lastName ? item.lastName : "-"
        };
      });
      setData(shopUserlistData);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchShopUserList();
  }, []);

  return (
    <Grid
      sx={{ background: theme.color?.background, borderRadius: "16px" }}
      display={"flex"}
      flexDirection={"column"}
      overflow={"hidden"}
    >
      <Grid
        height={"20%"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        px={4}
        py={5}
        borderBottom={theme.border?.smallGrey}
      >
        <Typography
          sx={{
            fontFamily: theme.font?.fontFamily.primary,
            fontSize: theme.font?.fontSize.large,
            fontWeight: theme.font?.fontWeight.thick,
          }}
        >
          User Access
        </Typography>
        {userAccessPermissions("create") && (
          <Button
            sx={{ ...buttonStyles.containedSecondary }}
            component={Link}
            to="/adduseraccess"
          >
            Add User
          </Button>
        )}
      </Grid>
      <Grid p={2}>
        {userAccessPermissions("read") && (
          <InfiniteTable
            header={columns}
            contentItems={data}
            hasMoreRecords={lastKey !== null}
            isInitialLoading={data.length === 0 && loading}
            totalRecords={totalCount}
            editMode={true}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default UserAccessNew;
